"use client";
import { useEffect, useState } from "react";
import { cn, updateSearchParams } from "@/lib/utils";
import { Checkbox } from "@/components/ui/checkbox";
import { useSearchParams } from "next/navigation";
import { useRouter } from "@bprogress/next";
import { Label } from "@/components/ui/label";
import { trans } from "@/service/i18n/i18n";

export function CheckboxFilter({
  filter,
  onChange = () => {},
  preventSearchParamsUpdate = false,
  labelClassName,
}: {
  filter: Filter;
  onChange?: () => void;
  preventSearchParamsUpdate?: boolean;
  labelClassName?: string;
}) {
  const { name, label } = filter;

  const [currentValue, setCurrentValue] = useState(filter.value ?? null);
  const searchParams = useSearchParams();
  const router = useRouter();

  useEffect(() => {
    if (searchParams.has(name)) {
      setCurrentValue(filter.value ?? false);
    } else {
      setCurrentValue(false);
    }
  }, [searchParams, name, filter.value]);

  return (
    <div className={cn("flex gap-2", "items-center")}>
      <Checkbox
        onCheckedChange={(value) => {
          onChange(value);
          if (!preventSearchParamsUpdate) {
            updateSearchParams(name, value === false ? null : value, router);
          }
        }}
        checked={currentValue}
        id={name}
        className={cn("bg-white")}
      />
      <Label
        dangerouslySetInnerHTML={{ __html: trans(label) }}
        className={cn("block", labelClassName)}
        htmlFor={name}
      />
    </div>
  );
}
